
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.897","height":"14.897"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 320"}},[_c('g',{attrs:{"data-name":"그룹 318"}},[_c('g',{attrs:{"data-name":"그룹 294"}},[_c('path',{attrs:{"data-name":"선 59","fill":"none","stroke":"#3c3c3c","stroke-linecap":"round","stroke-width":"2","d":"M1.449 1.734l12 11.428"}})]),_c('g',{attrs:{"data-name":"그룹 318"}},[_c('path',{attrs:{"data-name":"선 59","fill":"none","stroke":"#3c3c3c","stroke-linecap":"round","stroke-width":"2","d":"M1.735 13.448l11.428-12"}})])])])])
          )
        }
      }
    